import { render, staticRenderFns } from "./articlePage.vue?vue&type=template&id=8f354044&scoped=true&"
import script from "./articlePage.vue?vue&type=script&lang=js&"
export * from "./articlePage.vue?vue&type=script&lang=js&"
import style0 from "./articlePage.vue?vue&type=style&index=0&id=8f354044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f354044",
  null
  
)

export default component.exports